export const userRole = {
  RENTER: "RENTER",
  RESIDENT: "RESIDENT",
  OWNER: "OWNER",
  PANEL: "PANEL",
  PANEL_INSTALLER: "PANEL_INSTALLER",
  BOOKING: "BOOKING",
  CONTRACT: "CONTRACT"
};

export const userRoleMapper = {
  RENTER: "ผู้เช่า",
  RESIDENT: "ผู้อยู่อาศัย",
  OWNER: "ผู้ถือกรรมสิทธิ์",
  PANEL: "แผงควบคุม",
  PANEL_INSTALLER: "ผู้ติดตั้งแผงควบคุม",
  BOOKING: "ผู้จอง",
  CONTRACT: "ผู้ทำสัญญา"
};

export const inverseUserRoleMapper = Object.keys(userRoleMapper).reduce(
  (all, key) => {
    return { ...all, [userRoleMapper[key]]: key };
  },
  {}
);

export const genderMapper = {
  m: "ชาย",
  f: "หญิง"
};

export const subscriptionStatus = {
  ACTIVE: "ACTIVE",
  EXPIRED: "EXPIRED",
  CANCELLED: "CANCELLED",
  UNSUBSCRIBED: "UNSUBSCRIBED",
  FREE_TRIAL: "FREE_TRIAL",
  ONE_TIME: "ONE_TIME"
};

export const paymentStatus = {
  APPROVE: "A",
  INQUIRY: "I",
  VOID: "V",
  SETTLE: "S",
  REFUND: "R",
  REFUND_STATUS: "RS"
};

export const permissionRole = {
  ADMIN: "Admin",
  MK: "MK",
  CRM: "CRM",
  CC: "CC",
  HC: "HC",
  JU: "JU",
  FI: "FI",
  AC: "AC",
  REA: "REA",
  CS: "CS",
  HOS: "HOS",
  HOA: "HOA",
  LMA: "LMA",
  LMC: "LMC",
  LMM: "LMM",
  WSADMIN: "WSADMIN",
  SADMIN: "SADMIN",
  CDS: "CDS",
  SP: "SP",
  NS: "NS"
}

export const permissionRoles = [
  "Admin",
  "MK",
  "CRM",
  "CC",
  "HC",
  "JU",
  "FI",
  "AC",
  "REA",
  "CS",
  "HOS",
  "HOA",
  "LMA",
  "LMC",
  "LMM",
  "WSADMIN",
  "SADMIN",
  "CDS"
]

export const projectTypeMapper = {
  HIGH: "H",
  LOW: "L",
  BUILDING: "B"
}

export const receiptTypeTH = {
  RECEIPT_AND_TAX_INVOICE: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
  FREE_PURCHASE_RECEIPT_AND_TAX_INVOICE: "ใบเสร็จรับเงิน/ใบกำกับภาษี",
  TAX_INVOICE: "ใบกำกับภาษี",
  CREDIT_NOTE: "ใบลดหนี้"
}

export const reversePaymentStatus = Object.keys(paymentStatus).reduce(
  (all, key) => {
    return { ...all, [paymentStatus[key]]: key };
  },
  {}
);

export const ruejaiClubPackageType = {
  SALES_PACKAGE: "SALES_PACKAGE",
  VOUCHER: "VOUCHER"
}

export const localization = {
  TH: "th-TH",
  EN: "en-TH",
  CN: "zh-CN"
}

export const residentReportType = {
  DATA: "data",
  CONTACT: "contact"
}

export const voucherType = {
  NEWS: "1",
  ACTIVITY: "2",
  PRIVILEGE: "3"
}

export const actionActivityHistory = {
  ADD: "ได้เพิ่ม",
  ADD_BY_ADMIN: "(Admin) ได้เพิ่ม",
  REMOVE_BY_ADMIN: "(Admin) ได้ลบ",
  REMOVE: "ได้ลบ",
  VERIFY: "ได้ยืนยันตัวตนแล้ว ",
  FROM: "จากการเป็น",
  TO_BE: "เป็น"
}

export const memberActivityStatus = {
  OWNER: "เจ้าของ",
  RENTER: "ผู้เช่า",
  RESIDENT: "ผู้อยู่อาศัย",
  VISITOR: "คนทั่วไป",
  PROPRIETOR: "ผู้ถือกรรมสิทธิ์",
  PANEL_INSTALLER: "PANEL_INSTALLER",
  PANEL: "PANEL",
  CONTRACT: "CONTRACT"
}

export const createPackageType = {
  SUBSCRIPTION: "SUBSCRIPTION",
  RUEJAICLUB: "RUEJAICLUB"
}

export const leadHomeManagementStatusTH = {
  PENDING: "รอติดต่อ",
  IN_PROCESS: "กำลังทำงาน",
  EXPIRED: "หมดอายุ",
  CLOSED: "ปิดการขาย",
  FOLLOW: "ติดตามผล",
  CAN_NOT_CONTACT: "ติดต่อไม่ได้",
  REJECT: "ไม่สนใจ",
  POTENTIAL: "POTENTIAL",
  SALED: "ขายบ้าน / ให้เช่า",
  NOT_MOVE_IN: "ยังไม่ได้เข้าอยู่",
  SELF_SERVICE: "ดูแล/ฉีดเอง",
  IN_CONTRACT: "ติดสัญญาแล้ว",
  DO_NOT_CONTACT: "ห้ามโทร"
}

export const leadHomeManagementStatusENG = {
  PENDING: "PENDING",
  IN_PROCESS: "IN_PROCESS",
  EXPIRED: "EXPIRED",
  CLOSED: "CLOSED",
  FOLLOW: "FOLLOW",
  CAN_NOT_CONTACT: "CAN_NOT_CONTACT",
  REJECT: "REJECT",
  POTENTIAL: "POTENTIAL",
  SALED: "SALED",
  NOT_MOVE_IN: "NOT_MOVE_IN",
  SELF_SERVICE: "SELF_SERVICE",
  IN_CONTRACT: "IN_CONTRACT",
  DO_NOT_CONTACT: "DO_NOT_CONTACT"
}

export const leadHomeStatusMapper = [
  { label: "รอติดต่อ", value: "PENDING" },
  { label: "ปิดการขาย", value: "CLOSED" },
  { label: "ติดตามผล", value: "FOLLOW" },
  { label: "ติดต่อไม่ได้", value: "CAN_NOT_CONTACT" },
  { label: "ไม่สนใจ", value: "REJECT" },
  { label: "POTENTIAL", value: "POTENTIAL" },
  { label: "ขายบ้าน / ให้เช่า", value: "SALED" },
  { label: "ยังไม่ได้เข้าอยู่", value: "NOT_MOVE_IN" },
  { label: "ดูแล/ฉีดเอง", value: "SELF_SERVICE" },
  { label: "ติดสัญญาแล้ว", value: "IN_CONTRACT" },
  { label: "ห้ามโทร", value: "DO_NOT_CONTACT" }
];

export const leadManagementReason = [
  { label: "เบอร์ไม่ถูกต้อง", value: "CONTACT_NUMBER_NOT_CORRECT" },
  { label: "ไม่รับสาย", value: "NOT_ANSWER" }
]

export const leadStatus = {
  PENDING: "รอการทำ",
  IN_PROCESS: "กำลังทำ",
  DONE: "เสร็จสิ้น",
  EXPIRED: "หมดอายุ"
}

export const roleUserStatus = {
  OWNER: "OWNER",
  RESIDENT: "RESIDENT",
  RENTER: "RENTER",
  PANEL_INSTALLER: "PANEL_INSTALLER",
  PANEL: "PANEL",
  BOOKING: "BOOKING",
  CONTRACT: "CONTRACT"
}

export const serviceType = {
  SERVICE: "SERVICE",
  PRODUCT: "PRODUCT"
};

export const receiptTypeEN = {
  RECEIPT_AND_TAX_INVOICE: 'RECEIPT_AND_TAX_INVOICE',
  FREE_PURCHASE_RECEIPT_AND_TAX_INVOICE: 'FREE_PURCHASE_RECEIPT_AND_TAX_INVOICE',
  TAX_INVOICE: 'TAX_INVOICE',
  CREDIT_NOTE: 'CREDIT_NOTE'
}

export const daysOfWeek = [
  { label: "วันจันทร์", value: "MONDAY" },
  { label: "วันอังคาร", value: "TUESDAY" },
  { label: "วันพุธ", value: "WEDNESDAY" },
  { label: "วันพฤหัสบดี", value: "THURSDAY" },
  { label: "วันศุกร์", value: "FRIDAY" },
  { label: "วันเสาร์", value: "SATURDAY" },
  { label: "วันอาทิตย์", value: "SUNDAY" }
];

export const timeOfDay = [
  { label: "ช่วงเช้า", value: "MORNING" },
  { label: "ช่วงบ่าย", value: "AFTERNOON"}
]

export const datesOfMonth = Array.from(new Array(31)).map(
  (_, index) => index + 1
);

export const dateType = [
  { label: "ช่วงเวลา", value: "time" },
  { label: "วันที่", value: "date" },
  { label: "ทุกๆวัน", value: "week" },
  { label: "ทุกๆวันที่ ", value: "month" }
];

export const dateTypeMapping = {
  TIME: 'time',
  DATE: 'date',
  WEEK: 'week',
  MONTH: 'month'
};

export const sapServiceRecognizeRevenueType = {
  APPOINTMENT_REVENUE: "APPOINTMENT_REVENUE",
  ONETIME_REVENUE: "ONETIME_REVENUE"
}

export const ratingContactStatusMapping = [
  { label: "ติดต่อได้", value: "CONTACTED" },
  { label: "ติดต่อไม่ได้", value: "CAN_NOT_CONTACT" },
  { label: "ยังไม่ปิด", value: "NOT_CLOSED" },
];

export const filterRatingContactStatus =  [{ label: "ทั้งหมด", value: "" }].concat(
  ratingContactStatusMapping
);

export const actionBillingMapping = [
  { label: "กรุณาติดต่อลูกค้า", value: "CONTACT_USER" },
  { label: "กรุณาแนบเอกสาร", value: "NEED_DOCUMENT_BILLING" },
  { label: "ยืนยันเอกสาร", value: "WAITING_CONFIRM" },
  { label: "เสร็จสิ้น", value: "DONE" }
]

export const timeDuration = {
  MORNING: "MORNING",
  AFTERNOON: "AFTERNOON",
  FULL_DAY: "FULL_DAY",
  FULL_DAY_SPECIAL: "FULL_DAY_SPECIAL"
}

export const packagePeriodTypeMapping = [
  { label: "งานที่แพ็กเกจหมดอายุ", value: "EXPIRED_DATE" },
  { label: "งานที่แพ็กเกจมีนัดครั้งแรก", value: "FIRST_APPOINTMENT_DATE" },
]

export const conferenceBookingStatus = [ 
  { label: "รอยืนยัน", value: "PENDING" },
  { label: "ยืนยัน", value: "CONFRIMED" },
  { label: "เสร็จสิ้น", value: "DONE" },
  { label: "ยกเลิก", value: "CANCELED" },
];



// WEBPACK FOOTER //
// ./src/lib/mapper.js